import { useProjectContext } from "@hooks/context/useProjectContext";
import { Box, Tab, Tabs } from "@mui/material";
import * as RouteHelper from "@utils/routes";
import { Link, matchPath, useLocation } from "react-router-dom";

function useRouteMatch(patterns: readonly string[]) {
  const { pathname } = useLocation();

  for (let i = 0; i < patterns.length; i += 1) {
    const pattern = patterns[i];
    const possibleMatch = matchPath(pattern, pathname);
    if (possibleMatch !== null) {
      return possibleMatch;
    }
  }

  return null;
}
// interface DashboardPageTabsProps {}

export const DashboardPageTabs = (): JSX.Element => {
  const { selectedProject, contractorPackage } = useProjectContext();

  const routeMatch = useRouteMatch([
    RouteHelper.contractorDashboard(":projectId"),
    RouteHelper.contractorDashboardMonthly(":projectId"),
  ]);
  const currentTab = routeMatch?.pattern?.path;

  return (
    <Box>
      <Tabs value={currentTab}>
        <Tab
          label="All"
          value={RouteHelper.contractorDashboard(":projectId")}
          to={RouteHelper.contractorDashboard(selectedProject.id)}
          component={Link}
        />
        <Tab
          label="Monthly"
          value={RouteHelper.contractorDashboardMonthly(":projectId")}
          to={RouteHelper.contractorDashboardMonthly(selectedProject.id)}
          component={Link}
        />
      </Tabs>
    </Box>
  );
};
